import { NumberFilter } from "@react3l/advanced-filters";
import { Skeleton } from "antd";
import { HOME_CONTROLLER_MASTER_ROUTE } from "config/route-consts";
import { AxisResponse } from "models/Dashboard";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { dashboardRepository } from "repositories/dashboard-repository";
import { summarizeHc } from "./dashboard-data";

const numberFormat = new Intl.NumberFormat("vi-VN");
const percentFormat = new Intl.NumberFormat("vi-VN", { maximumFractionDigits: 1 });

export default function HcHealth() {
  const [data, setData] = useState<AxisResponse>();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const subscription = dashboardRepository
      .statisticHomeController({
        time: new NumberFilter({ equal: 1 }),
        type: new NumberFilter({ equal: 1 }),
        skip: 0,
        take: 1,
      })
      .subscribe({
        next: (response: AxisResponse) => {
          setData(response);
          setLoading(false);
        },
        error: () => setLoading(false),
      });
    return () => subscription.unsubscribe();
  }, []);

  if (loading) return <Skeleton active paragraph={{ rows: 4 }} />;

  const { rows, online, offline, total } = summarizeHc(data);
  if (total === 0) return <p className="dashboard-master__empty">Chưa có dữ liệu Home Controller</p>;

  const onlineRate = (online / total) * 100;

  return (
    <div className="hc-health">
      <div className="hc-health__summary">
        <div>
          <div className="hc-health__rate tabular-nums">{percentFormat.format(onlineRate)}%</div>
          <div className="hc-health__caption tabular-nums">
            {numberFormat.format(online)} / {numberFormat.format(total)} HC đang trực tuyến
          </div>
        </div>
        {offline > 0 && (
          <Link
            className="hc-health__alert tabular-nums"
            to={`${HOME_CONTROLLER_MASTER_ROUTE}?homeControllerActiveStatusId[equal]=2&skip=0&take=10`}
          >
            <i className="tio-wifi_off" aria-hidden />
            {numberFormat.format(offline)} HC ngoại tuyến
            <i className="tio-chevron_right" aria-hidden />
          </Link>
        )}
      </div>

      <ul className="hc-health__rows">
        {rows.map((row) => {
          const rowRate = row.total ? (row.online / row.total) * 100 : 0;
          const tooltip = `${row.name}: ${numberFormat.format(row.online)} trực tuyến, ${numberFormat.format(
            row.offline
          )} ngoại tuyến`;
          return (
            <li key={row.name} className="hc-health__row" title={tooltip}>
              <span className="hc-health__name">{row.name}</span>
              <span className="hc-health__bar" aria-hidden>
                {row.online > 0 && <span className="hc-health__bar-on" style={{ width: `${rowRate}%` }} />}
              </span>
              <span className="hc-health__value tabular-nums">
                {numberFormat.format(row.online)}
                <span className="hc-health__value-total"> / {numberFormat.format(row.total)}</span>
              </span>
            </li>
          );
        })}
      </ul>

      <div className="hc-health__legend">
        <span>
          <i className="hc-health__dot hc-health__dot--on" aria-hidden />
          Trực tuyến
        </span>
        <span>
          <i className="hc-health__dot hc-health__dot--off" aria-hidden />
          Ngoại tuyến
        </span>
      </div>
    </div>
  );
}
